import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {EditorsListProviderService} from "../../services/editorsListProvider/editors-list-provider.service";
declare var Yiit;

@Component({
  selector: 'app-realtime-users',
  templateUrl: './realtime-users.component.html',
  styleUrls: ['./realtime-users.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RealtimeUsersComponent implements OnInit {

  public Yiit = Yiit;
  public usersList = {};
  private collapsed = true;

  constructor(protected editorsProvider: EditorsListProviderService, protected cd: ChangeDetectorRef) { }

  ngOnInit() {
    this.editorsProvider.list.subscribe((usersList)=>{
       this.usersList = (usersList) ? usersList : {};
    });
  }

  public toggleVisibility(){
    this.collapsed = !this.collapsed;
  }

  public getUserAvatar(item){
    return item.avatar !== null ? ("url(" + item.avatar + ")") : "none"
  }

  public getUserName(item){
    return item.name;
  }

  getListCount(){
    return Object.keys(this.usersList).length;
  }

  getUserColor(item){
    return item.color;
  }

  getUserCursorVisibility(item){
    return item.trackCursor;
  }

  toggleCursor(item){
    this.editorsProvider.setUserCursorVisibility(!item.trackCursor, item.sid);
  }

}
